import Api from './api';

const sInvoiceExportInEXCELRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/si/excel/', data, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}



export default {
    sInvoiceExportInEXCELRequest
}



// WEBPACK FOOTER //
// ./src/api/apiSInvoices.js